<template>
    <cadastro-simples-form
        endpoint="grupo-conceito"
        rota-base="/admin/grupo-conceito"
        titulo-singular="Grupo de Conceito"
        :campos-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-form>
</template>

<script>
import CadastroSimplesForm from '@/components/cadastros-auxiliares/cadastro-simples-form.vue'
export default { components: { CadastroSimplesForm } }
</script>
